import { FC, ReactNode } from 'react';
import {
  CloseButton,
  Dialog as ChakraDialog,
  DialogRootProps,
  Heading,
  Stack,
  Text,
} from '@chakra-ui/react';

export type DialogProps = DialogRootProps & {
  showCloseButton?: boolean;
  header?: ReactNode;
  subHeader?: ReactNode;
  footer?: ReactNode;
};

export const Dialog: FC<DialogProps> = ({
  children,
  header,
  subHeader,
  footer,
  showCloseButton = true,
  ...props
}) => (
  <ChakraDialog.Root
    motionPreset="slide-in-bottom"
    placement="center"
    {...props}
  >
    <ChakraDialog.Backdrop />

    <ChakraDialog.Positioner>
      <ChakraDialog.Content>
        {showCloseButton && (
          <ChakraDialog.CloseTrigger asChild>
            <CloseButton />
          </ChakraDialog.CloseTrigger>
        )}

        {(header || subHeader) && (
          <ChakraDialog.Header>
            <Stack gap={4}>
              {typeof header === 'string' ? (
                <Heading color="fg" textStyle="header">
                  {header}
                </Heading>
              ) : (
                header
              )}

              {typeof subHeader === 'string' ? (
                <Text color="fg.muted" textStyle="md">
                  {subHeader}
                </Text>
              ) : (
                subHeader
              )}
            </Stack>
          </ChakraDialog.Header>
        )}

        <ChakraDialog.Body py={4}>{children}</ChakraDialog.Body>
        {footer && <ChakraDialog.Footer>{footer}</ChakraDialog.Footer>}
      </ChakraDialog.Content>
    </ChakraDialog.Positioner>
  </ChakraDialog.Root>
);
